"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinimumAgeByLocationId = exports.getFlattenedCategories = void 0;
const getFlattenedCategories = (categories) => {
    const flattenedCategories = [];
    categories.forEach((category) => {
        flattenedCategories.push(category);
        category.childCategories.forEach((childCategory) => {
            flattenedCategories.push(childCategory);
        });
    });
    return flattenedCategories;
};
exports.getFlattenedCategories = getFlattenedCategories;
const getMinimumAgeByLocationId = (locationId, category) => {
    var _a;
    const locationOverride = (_a = category.categoryLocationOverrides) === null || _a === void 0 ? void 0 : _a.find((override) => override.locationId === locationId);
    if (locationOverride && locationOverride.minimumAge !== null) {
        return locationOverride.minimumAge;
    }
    return category.defaultMinimumAge;
};
exports.getMinimumAgeByLocationId = getMinimumAgeByLocationId;
//# sourceMappingURL=index.js.map